class RecentlyViewedHandles extends HTMLElement {
  constructor() {
    super();

    this.productContainer = this.querySelector('#recently-viewed-products');
    this.maxStored = 16; // how many items to keep in localStorage AND render

    const getProductHandle = this.getUrlFromHandle();
    this.recentlyProductViewed = getProductHandle || null; 

    if (getProductHandle) {
      let stored = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

      // Remove if already exists (so we can re-add at end = most recent)
      stored = stored.filter(h => h !== getProductHandle);

      // Add to end
      stored.push(getProductHandle);

      // Keep only last 16
      if (stored.length > this.maxStored) {
        stored = stored.slice(-this.maxStored);
      }

      localStorage.setItem('recentlyViewedProducts', JSON.stringify(stored));
    }
      this.swiperWrapper = this.querySelector('.swiper-wrapper');
      this.swiperInstance = null;
  }

  getUrlFromHandle() {
    const url = window.location.href;
    const handle = url.split("/products/")[1]?.split("?")[0]; 
    return handle;
  }

  connectedCallback() {
    this.render();
    this.loadRecentlyViewed();
  }

  render() {
    this.productContainer.innerHTML = `<p>Loading your recently viewed products...</p>`;
  }

  loadRecentlyViewed() {
    const container = this.productContainer;

    // Read from localStorage
    const localHandles = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

    // Wrap single handle from constructor in an array
    const metafieldHandles = this.recentlyProductViewed ? [this.recentlyProductViewed] : [];

    // Combine handles, remove duplicates, keep only the last 16
    const combinedHandles = Array.from(new Set([...metafieldHandles, ...localHandles])).slice(-this.maxStored);

    if (combinedHandles.length === 0) {
      container.innerHTML =
        '<p class="empty-recently-viewed">Your recently-viewed is empty</p>';
      return;
    }

    // Fetch each product
    Promise.all(
      combinedHandles.map((handle) =>
        fetch(`/?sections=recently-viewed-products&product_handles=${handle}`)
          .then((res) => res.ok ? res.json() : null)
          .then((data) => {
            if (data && data['recently-viewed-products']) {
              return { html: data['recently-viewed-products'], handle };
            }
            return null;
          })
          .catch((err) => {
            console.error('Fetch error for', handle, err);
            return null;
          })
      )
    ).then((results) => {
      const validItems = results.filter((item) => item !== null);
      if (validItems.length === 0) {
        container.innerHTML =
          '<p class="empty-recently-viewed">Could not load recently-viewed</p>';
        return;
      }

      container.innerHTML = '';
      validItems.forEach((item) => {
        const parser = new DOMParser();
        const productSection = parser.parseFromString(item.html, "text/html");
        const productItem = productSection.querySelector(".viewed-card-item");
        const wrapper = document.createElement('div');
        wrapper.classList.add('recently-viewed-item', 'swiper-slide');
        wrapper.innerHTML = productItem.outerHTML;
        container.appendChild(wrapper);
      });
      this.initializeSwiper()
    });
  }
  initializeSwiper() {
    if (!window.Swiper) {
      const swiperScript = document.createElement('script');
      swiperScript.src =
        'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperScript.onload = () => this.initSwiperInstance();
      document.head.appendChild(swiperScript);
    } else {
      this.initSwiperInstance();
    }
  }
  initSwiperInstance() {
    this.swiperInstance = new Swiper(this, {
      slidesPerView: 4.5,
      spaceBetween: 30,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: { slidesPerView: 1.2, spaceBetween: 10 },
        768: { slidesPerView: 2.5, spaceBetween: 15 },
        1024: { slidesPerView: 4, spaceBetween: 20 },
      },
    });
  }
}

customElements.define("recently-viewed-product", RecentlyViewedHandles);
